module.exports = __webpack_public_path__ + "static/media/heeremafaailure.231171ef.PNG";